import * as actions from 'actions/simpleSuggestionActions';
import omit from 'lodash/omit';
import { SUCCESS, ERROR, LOADING } from 'utils/asyncStatusHelper';
export default function suggestions(state = {}, action) {
    switch (action.type) {
        case actions.AUTO_SUGGESTION_REQUEST:
            return Object.assign({}, state, {
                [action.suggestionType]: Object.assign({}, state[action.suggestionType], {
                    asyncStatus: LOADING
                })
            });
        case actions.AUTO_SUGGESTION_SUCCESS:
            return {
                [action.suggestionType]: {
                    asyncStatus: SUCCESS,
                    data: action.data
                }
            };
        case actions.AUTO_SUGGESTION_ERROR:
            return {
                [action.suggestionType]: {
                    asyncStatus: ERROR,
                    error: action.error
                }
            };
        case actions.RESET_AUTO_SUGGESTION:
            return omit(state, [action.suggestionType]);
        default:
            return state;
    }
}
